import { useEffect } from "react";

const SITE = {
  name: "Citirex",
  base: "https://citirex.com",
  defaultDesc:
    "Citirex is a Los Angeles based performance marketing agency generating high-intent leads, live calls and hot transfers across the eight largest insurance and home-services verticals.",
  defaultImage:
    "https://images.pexels.com/photos/35291221/pexels-photo-35291221.jpeg",
};

const setMeta = (selector, attr, value) => {
  if (typeof document === "undefined") return;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [name, val] = selector.replace(/[[\]"']/g, "").split("=");
    el.setAttribute(name, val);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

const setLink = (rel, href) => {
  if (typeof document === "undefined") return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

/**
 * Lightweight per-route document head manager.
 * Sets title, description, canonical, OG and Twitter tags.
 */
export default function PageHead({
  title,
  description,
  path = "/",
  image,
  type = "website",
}) {
  useEffect(() => {
    const fullTitle = title
      ? `${title} — ${SITE.name}`
      : `${SITE.name} — Premium B2B Lead Generation | Los Angeles`;
    const desc = description || SITE.defaultDesc;
    const img = image || SITE.defaultImage;
    const url = `${SITE.base}${path}`;

    document.title = fullTitle;
    setMeta('meta[name="description"]', "content", desc);
    setLink("canonical", url);

    setMeta('meta[property="og:type"]', "content", type);
    setMeta('meta[property="og:site_name"]', "content", SITE.name);
    setMeta('meta[property="og:title"]', "content", fullTitle);
    setMeta('meta[property="og:description"]', "content", desc);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[property="og:image"]', "content", img);

    setMeta('meta[name="twitter:card"]', "content", "summary_large_image");
    setMeta('meta[name="twitter:title"]', "content", fullTitle);
    setMeta('meta[name="twitter:description"]', "content", desc);
    setMeta('meta[name="twitter:image"]', "content", img);
  }, [title, description, path, image, type]);

  return null;
}

export { SITE };
